import { render } from "./MobileRoot.vue?vue&type=template&id=b0f56bbe"
import script from "./MobileRoot.vue?vue&type=script&lang=js"
export * from "./MobileRoot.vue?vue&type=script&lang=js"

import "./MobileRoot.vue?vue&type=style&index=0&id=b0f56bbe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__